export default "__VITE_ASSET__A0hYUtF9__"